import React, { Component } from 'react';
import { Grid, Button } from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';
import { Field, reduxForm } from 'redux-form';
import validate from './validations/employerBaseValidation';
import asyncValidate from './validations/oldPasswordAsyncValidation';
import { renderTextField } from '../../../../helpers';
import { withTranslation } from 'react-i18next'; // Import withTranslation

const styles = theme => ({});

class EmployerBaseForm extends Component {
    render() {
        const { handleSubmit, t } = this.props; // Destructure t from props

        return (
            <form onSubmit={handleSubmit}>
                <React.Fragment>
                    <Grid container spacing={24} style={{ marginTop: 40, marginBottom: 10 }}>
                        <Grid item xs={12}>
                            <Field
                                disabled
                                name="email"
                                fullWidth
                                component={renderTextField}
                                label={t("email")}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Field
                                name="oldPassword"
                                type="password"
                                fullWidth
                                component={renderTextField}
                                label={t("oldPassword")}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Field
                                fullWidth
                                name="newPassword"
                                type="password"
                                component={renderTextField}
                                label={t("newPassword")}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Field
                                fullWidth
                                name="confirmNewPassword"
                                type="password"
                                component={renderTextField}
                                label={t("confirmNewPassword")}
                            />
                        </Grid>
                        <Grid item xs={12} align="right">
                            <Button
                                variant="contained"
                                type="submit"
                                color="primary"
                                className="next"
                            >
                                {t("edit")}
                            </Button>
                        </Grid>
                    </Grid>
                </React.Fragment>
            </form>
        );
    }
}

export default withStyles(styles)(
    reduxForm({
        form: 'EmployerBaseForm', // a unique identifier for this form
        validate,
        asyncValidate,
        enableReinitialize: true
    })(withTranslation()(EmployerBaseForm)) // Wrap with withTranslation
);

//import React, { Component } from 'react';
//import { Grid, Button } from '@material-ui/core';
//import withStyles from '@material-ui/core/styles/withStyles';
//import { Field, reduxForm } from 'redux-form';
//import validate from './validations/employerBaseValidation';
//import asyncValidate from './validations/oldPasswordAsyncValidation';
//import { renderTextField } from '../../../../helpers';
//import { useTranslation } from 'react-i18next';

//const styles = theme => ({});

//class EmployerBaseForm extends Component {
//    render() {
//        const { handleSubmit } = this.props;
//        const { t } = this.props;

//        return (
//            <form onSubmit={handleSubmit}>
//                <React.Fragment>
//                    <Grid container spacing={24} style={{ marginTop: 40, marginBottom: 10 }}>
//                        <Grid item xs={12}>
//                            <Field
//                                disabled
//                                name="email"
//                                fullWidth
//                                component={renderTextField}
//                                label={t("email")}
//                            />
//                        </Grid>
//                        <Grid item xs={12}>
//                            <Field
//                                name="oldPassword"
//                                type="password"
//                                fullWidth
//                                component={renderTextField}
//                                label={t("oldPassword")}
//                            />
//                        </Grid>
//                        <Grid item xs={12}>
//                            <Field
//                                fullWidth
//                                name="newPassword"
//                                type="password"
//                                component={renderTextField}
//                                label={t("newPassword")}
//                            />
//                        </Grid>
//                        <Grid item xs={12}>
//                            <Field
//                                fullWidth
//                                name="confirmNewPassword"
//                                type="password"
//                                component={renderTextField}
//                                label={t("confirmNewPassword")}
//                            />
//                        </Grid>
//                        <Grid item xs={12} align="right">
//                            <Button
//                                variant="contained"
//                                type="submit"
//                                color="primary"
//                                className="next"
//                            >
//                                {t("edit")}
//                            </Button>
//                        </Grid>
//                    </Grid>
//                </React.Fragment>
//            </form>
//        );
//    }
//}

//const mapStateToProps = state => ({
//    // Add any necessary state mappings here
//});

//const mapDispatchToProps = dispatch => ({
//    // Add any necessary dispatch mappings here
//});

//export default withStyles(styles)(
//    reduxForm({
//        form: 'EmployerBaseForm', // a unique identifier for this form
//        validate,
//        asyncValidate,
//        enableReinitialize: true
//    })(EmployerBaseForm)
//);

//import React, { Component } from 'react';
//import { Grid, Button } from '@material-ui/core';
//import withStyles from '@material-ui/core/styles/withStyles';
//import { Field, reduxForm } from 'redux-form';
//import validate from './validations/employerBaseValidation';
//import asyncValidate from './validations/oldPasswordAsyncValidation';
//import { renderTextField } from '../../../../helpers';

//const styles = theme => ({
//});

//class EmployerBaseForm extends Component {

//    render() {
//        const { handleSubmit } = this.props;

//        return (
//            <form onSubmit={handleSubmit} >
//                <React.Fragment>
//                    <Grid container spacing={24} style={{ marginTop: 40, marginBottom: 10 }}>                        
//                        <Grid item xs={12}>
//                            <Field
//                                disabled
//                                name="email"
//                                fullWidth
//                                component={renderTextField}
//                                label="E-mail"
//                            />
//                        </Grid>
//                        <Grid item xs={12}>
//                            <Field
//                                name="oldPassword"
//                                type="password"
//                                fullWidth
//                                component={renderTextField}
//                                label="Стара парола"
//                            />
//                        </Grid>
//                        <Grid item xs={12}>
//                            <Field
//                                fullWidth
//                                name="newPassword"
//                                type="password"
//                                component={renderTextField}
//                                label="Нова парола"
//                            />
//                        </Grid>
//                        <Grid item xs={12}>
//                            <Field
//                                fullWidth
//                                name="confirmNewPassword"
//                                type="password"
//                                component={renderTextField}
//                                label="Повторете новата парола"
//                            />
//                        </Grid>
//                        <Grid item xs={12} align="right">
//                            <Button
//                                variant="contained"
//                                type="submit"
//                                color="primary"
//                                className="next"                                
//                            >
//                                Редактирай
//                            </Button>
//                        </Grid>
//                    </Grid>
//                </React.Fragment>
//            </form>
//        );
//    }
//}

//export default withStyles(styles)(reduxForm({
//    form: 'EmployerBaseForm', // a unique identifier for this form
//    validate,
//    asyncValidate,
//    enableReinitialize: true
//})(EmployerBaseForm));